<template>
    <div v-if="settings.show">
        <div class="popupModal" :class="{active: showLogInModal}">
            <div class="loginModal__wrapper" @click="underlayClick">
                <div class="loginModal__content" id="popupModal__content">
                    <div class="logo__wrapper" v-if="false">
                        <img src="@/assets/icons/AV_logo.svg">
                    </div>
                    <div class="logIn-top__wrapper">
                        <div class="title-wrapper">
                            <a :class="{active: this.currentForm == 'login'}" @click.prevent="toggleForm('login')"
                               class="sign-in__title" href="#">{{translate('signIn_signIn_title')}}</a>
                            <a :class="{active: this.currentForm == 'register'}"
                               @click.prevent="toggleForm('register')"
                               class="sing-up__title" href="#">{{translate('signIn_signUp_title')}}</a>
                        </div>
                        <div class="social-group__btn">
                            <button class="google-btn">
                                <div @click="onGoogleSingIn">
                                    <div class="google-btn__content">
                                        <div class="google-btn__icon"><img src="@/assets/icons/ic_google_logo.svg" alt=""></div>
                                        <div class="google-btn__text">{{translate('signIn_Register', ['Google'])}}</div>
                                    </div>
                                </div>
                            </button>
                            <button class="facebook-btn">
                                <div @click="onFacebookSignIn">
                                    <div class="facebook-btn__content">
                                        <div class="facebook-btn__icon"><img src="@/assets/icons/ic_facebook_logo.svg" alt=""></div>
                                        <div class="facebook-btn__text">{{translate('signIn_Register', ['Facebook'])}}
                                        </div>
                                    </div>
                                </div>
                            </button>
                            <v-facebook-login @sdk-init="sdkLoaded" app-id="770275700057951" hidden></v-facebook-login>
                            <button class="pin-btn" @click="onPinSignInBtnClick" v-if="settings.showPinLoginOption">
                                <div>
                                    <div class="pin-btn__content">
                                        <div class="pin-btn__text">{{translate('signIn_Pin')}}
                                        </div>
                                    </div>
                                </div>
                            </button>
                        </div>
                        <div class="logIn-bottom__wrapper" v-if="this.currentForm == 'login'">
                            <div class="button-group__subtitle">{{translate('signIn_enter_using_email')}}</div>
                            <form class="sign-in__form">
                                <div class="sign-in__wrapper">
                                    <div class="input-wrapper">
                                        <div class="input-icon"><i class="fas fa-envelope"></i></div>
                                        <input id="email" :placeholder="translate('signIn_email_hint')" class="sign-input" type="email" v-model="signIn.email">
                                    </div>
                                    <div class="input-wrapper">
                                        <div class="input-icon"><i class="fas fa-unlock-alt"></i></div>
                                        <input class="sign-input" :placeholder="translate('signIn_password_hint')" :type="type" v-model="signIn.password">
                                    </div>
                                </div>
                            </form>
                            <div class="input-btn__wrapper" @click="logInEmail">
                                <a class="sign-in__button">{{translate('signIn_signInBtn')}}</a>
                            </div>
                        </div>
                        <div v-else>
                            <div class="logIn-bottom__wrapper">
                                <div class="button-group__subtitle">{{translate('signIn_RegisterWithEmail')}}</div>
                                <form class="sign-up__form">
                                    <div class="sign-up__wrapper">
                                        <div class="input-wrapper">
                                            <div class="input-icon"><i class="fas fa-user"></i></div>
                                            <input :placeholder="translate('signIn_firstName_hint')" class="sign-input" type="text" v-model="signUp.first_name" required>
                                        </div>
                                        <div class="input-wrapper">
                                            <div class="input-icon"><i class="fas fa-user"></i></div>
                                            <input :placeholder="translate('signIn_lastName_hint')" class="sign-input" type="text" v-model="signUp.last_name" required>
                                        </div>
                                    </div>
                                    <div class="input-wrapper">
                                        <div class="input-icon"><i class="fas fa-envelope"></i></div>
                                        <input :placeholder="translate('signIn_email_hint')" class="sign-input" type="email" v-model="signUp.email" required>
                                    </div>
                                    <div class="input-wrapper">
                                        <div class="input-icon"><i class="fas fa-unlock-alt"></i></div>
                                        <input :placeholder="translate('signIn_password_hint')" class="sign-input" :type="type" v-model="signUp.password"
                                               @focus="onPasswordFocus"
                                               @blur="onPasswordFocusLost" required>
                                    </div>
                                    <passwordValidation :settings='passwordValidationSettings'></passwordValidation>
                                    <div class="checkBox-wrapper">
                                        <input class="sign-up__checkbox" id="Terms" name="" type="checkbox"
                                               v-model="termsCheckbox"
                                               true-value="yes"
                                               false-value="no">
                                        <label class="checkbox-title" for="Terms" id="checkbox-text">{{translate('signIn_agreeTo')}}
                                            <a
                                                    @click="this.onTCClick" class="privecy" target="_blank">{{translate('signIn_tAndC')}}</a></label>
                                    </div>
                                    <div class="sign-btn__wrapper" v-if="termsCheckbox === 'yes'">
                                        <a @click="signUpUser" class="sign-up__button" v-if="!loginQuestion">{{translate('signIn_signUp_btn')}}</a>
                                        <a @click="signUpUser" class="sign-up__button" v-if="loginQuestion">{{translate('signIn_RegisterWithQuestion')}}</a>
                                    </div>
                                    <div class="sign-btn__wrapper" v-else>
                                        <button @click="signUpUser" class="sign-up__button" v-if="!loginQuestion" disabled>{{translate('signIn_signUp_btn')}}</button>
                                        <button @click="signUpUser" class="sign-up__button" v-if="loginQuestion" disabled>{{translate('signIn_RegisterWithQuestion')}}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import logAnalyticsEvent, {logError} from '@/helpers/analytics'
    import rateMixin from '@/mixins/rateMixin';
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import config from '@/api/config';
    import passwordValidation from "@/components/widgets/passwordValidation";
    import {VFBLogin as VFacebookLogin} from 'vue-facebook-login-component'
    import navMixin from "@/mixins/navMixin";
    import errorMixin from "@/mixins/errorMixin";
    export default {
        name: "logInModal",
        mixins: [mixin, rateMixin, navMixin, errorMixin],
        components: {
            passwordValidation,
            VFacebookLogin
        },
        data() {
            return {
                showLogInModal:  this.settings !== null,
                signIn: {
                    email: this.$route.query.email,
                    password: '',
                },
                signUp: {
                    email: this.$route.query.email,
                    first_name: this.$route.query.first_name,
                    last_name: this.$route.query.last_name,
                    password: '',
                },
                type: 'password',
                currentForm: 'login',
                termsCheckbox: false,
                passwordValidationSettings: {
                    validation: '',
                    show: false,
                },
                loginQuestion: false,
            }
        },
        watch: {
            settings(newValue) {
                this.showLogInModal = newValue !== null
            },
            'signUp.password'(item) {
                this.passwordValidationSettings.validation = item
            },
        },
        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },
        computed: {
            ...mapGetters({
                isAuthorized: 'auth/isAuthorized',
            }),
        },
        methods: {
            ...mapActions({
                logIn: 'auth/logIn',
                registration: 'auth/registration',
                fetchUserInfo: 'auth/fetchUserInfo',
            }),
            async onGoogleSingIn() {
                await this.GoogleSignIn({
                    becomeOwner: false,
                    redirect: false
                })
                logAnalyticsEvent(`signin_logingg`)
                if(this.isAuthorized) {
                    await this.onGotUserCreds()
                }
            },
            async onFacebookSignIn() {
                logAnalyticsEvent(`signin_loginfb`)
                await this.FacebookSignIn({
                    becomeOwner: false,
                    redirect: false
                })

                if(this.isAuthorized) {
                    await this.onGotUserCreds()
                }
            },
            async onPinSignInBtnClick() {
                console.log('onPinSignInClick')
                logAnalyticsEvent(`signin_pin_clk`)
                if(this.settings.onPinLoginChosen) {
                    this.settings.onPinLoginChosen()
                }
            },
            async logInEmail () {
                logAnalyticsEvent(`signin_login_email_click`)
                const body = {
                    email: this.signIn.email,
                    password: this.signIn.password,
                }
                try {
                    const response = await this.logIn(body)
                    if (response.data.access_token && response.data.refresh_token) {
                        this.setSignInState(response)
                        await this.tryChangeUserStatus()
                        logAnalyticsEvent(`signin_login_email_success`)
                        await this.onGotUserCreds()
                    }
                } catch (e) {
                    logError('signin_login_email_error', e.data.error.message || '')
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            },
            async signUpUser() {
                logAnalyticsEvent(`signin_register_create_acc_click`)
                if (!this.termsCheckbox) {
                    return
                }
                const body = {
                    email: this.signUp.email,
                    first_name: this.signUp.first_name,
                    last_name: this.signUp.last_name,
                    password: this.signUp.password,
                }
                try {
                    const response = await this.registration(body)
                    if (response.data.access_token && response.data.refresh_token) {
                        this.setSignInState(response)
                        await this.tryChangeUserStatus()
                        logAnalyticsEvent(`signin_register_create_acc_success`)
                        await this.onGotUserCreds()
                    }
                } catch (e) {
                    logError('signin_register_create_acc_error', e.data.error.message || '')
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            },
            async onGotUserCreds() {
                await this.fetchUserInfo()
                this.showLogInModal = false
                this.settings.onGotUserCreds()
            },
            underlayClick(e) {
                if(this.isClickOutOfBlock('popupModal__content', e.target) && this.settings.hideOnClickOutside) {
                    this.showLogInModal = false
                }
            },
            toggleForm(formName) {
                this.currentForm = formName;
                if (formName === 'forgot') {
                    logAnalyticsEvent(`signin_login_forgot_click`)
                }
            },
            onPasswordFocus() {
                this.passwordValidationSettings.show = true
            },

            onPasswordFocusLost() {
                this.passwordValidationSettings.show = this.signUp.password !== ''
            },
            showPassword() {
                if (this.type === 'password') {
                    this.type = 'password-text'
                } else {
                    this.type = 'password'
                }
            },
            onTCClick() {
                window.open(`${config.siteUrl}/${this.$ml.current}/terms/`, '_blank').focus()
            },
            async openSocialLink() {
                await this.FacebookSignIn({
                    becomeOwner: false,
                    redirect: false
                })
            },
        },
    }
</script>

<style scoped>
    .logo__wrapper {
        display: flex;
        justify-content: center;
        margin-top: 25px;
        margin-bottom: 54px;
    }
    .logIn-top__wrapper {
        background-color: #32324B;
        border-radius: 16px 16px 16px 16px;
    }
    .logIn-bottom__wrapper {
        background-color: #3F405C;
        border-radius: 0 0 16px 16px;
    }
    .social-group__btn {
        margin-top: 25px;
        padding-bottom: 40px;
        display: flex;
        flex-direction: column;
    }
    button.google-btn {
        border-radius: 6px;
        background-color: #D85140;
        margin-left: 24px;
        margin-right: 24px;
        margin-bottom: 16px;
        padding-bottom: 10px;
        padding-top: 10px;
        outline: none !important;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .google-btn__text {
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        margin-left: 10px;
        color: white;
    }
    button.facebook-btn {
        border-radius: 6px;
        background-color: #1976D2;
        margin-left: 24px;
        margin-right: 24px;
        padding-bottom: 10px;
        padding-top: 10px;
        outline: none !important;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    button.pin-btn {
        border-radius: 6px;
        background-color: #ffffff;
        color: black;
        margin-left: 24px;
        margin-right: 24px;
        margin-top: 16px;
        padding-bottom: 10px;
        padding-top: 10px;
        outline: none !important;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .pin-btn:hover {
        background-color: #8b8b8b;
        color: white;
    }
    .facebook-btn__text {
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        margin-left: 10px;
        color: white;
    }
    .pin-btn__text {
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        margin-left: 10px;
    }

    .google-btn__content {
        display: flex;
        align-items: center;
    }

    .facebook-btn__content {
        display: flex;
        align-items: center;
    }
    .pin-btn__content {
        display: flex;
        align-items: center;
    }
    .button-group__subtitle {
        margin-left: 43px;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        color: white;
        padding-top: 12px;
    }
    .sign-in__form {
        padding-left: 26px;
    }
    .sign-in__wrapper {
        margin-top: 30px;
    }
    .input-wrapper {
        display: flex;
        position: relative;
        vertical-align: top;
        padding-right: 48px;
        padding-bottom: 30px;
    }
    .input-icon {
        color: white;
        margin-right: 8px;
        height: 14px;
        width: 18px;
        margin-top: 3px;
    }
    input {
        outline: none;
        color: white;
        border: none;
        background-color: #3F405C;
        border-radius: 0;
    }

    input[type="text"] {
        width: 288px;
    }

    input[type="password"], input[type="email"], input[type="password-text"] {
        width: 288px;
    }

    input::-webkit-input-placeholder {
        color: #FFFFFF;
        font-family: Nunito;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
        opacity: 0.7;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus {
        -webkit-box-shadow: inset 0 0 0 50px #3F405C;
        -webkit-text-fill-color: white;
        transition: background-color 5000s ease-in-out 0s;
    }

    .sign-input {
        color: #FFFFFF;
        border-bottom: 3px solid #ffffff;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        padding-bottom: 5px;
    }
    .input-btn__wrapper {
        display: flex;
        flex-direction: column;
    }
    .sign-in__button {
        color: #2F2F2F;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        text-align: center;
        border-radius: 6px;
        background-color: #FFBF00;
        box-shadow: 0 2px 8px 0 #FFBF00;
        padding: 12px;
        margin-left: 24px;
        margin-right: 24px;
        margin-bottom: 24px;
    }
    .title-wrapper {
        display: flex;
        margin-left: 24px;
        padding-top: 25px;
    }

    .title-wrapper a {
        margin-right: 40px;
        color: #FFFFFF;
        font-family: Nunito;
        font-weight: 700;
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 18px;
        text-decoration: none;
        outline: none;
    }

    .title-wrapper a:hover {
        border-bottom: 3px solid #FFBF00;
        border-radius: 1px;
        text-decoration: none;
        outline: none;
        cursor: pointer;
    }

    .title-wrapper a.active {
        border-bottom: 3px solid #FFBF00;
        border-radius: 1px;
        text-decoration: none;
        outline: none;
        cursor: pointer;
    }
    .sign-up__form {
        margin-top: 8px;
        padding-left: 24px;
    }
    .show-password {
        position: absolute;
        left: 290px;
        top: 4px;
        color: white;
    }
    .checkBox-wrapper {
        display: flex;
    }

    input[type="checkbox"] {
        display: none;
    }

    label {
        margin-bottom: 0 !important;
        cursor: default;
        position: relative;
        width: 100%;
        color: #ffffff;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        padding-left: 30px;
        text-align: start;
    }

    label .checkbox-title {
        padding-left: 25px;
    }

    label.checkbox-title:before {
        content: " ";
        color: #000;
        display: inline-block;
        font: 15px/20px FontAwesome;
        position: absolute;
        top: 0;
        left: 0;
        text-align: center;
        background: linear-gradient(180deg, #3F405C 0%, #3F405C 100%);
        height: 22px;
        width: 22px;
        border: 2px solid #FFBF00;
        border-radius: 3px;
    }

    input:checked + label.checkbox-title:before {
        content: "\2714";
        background: #FFBF00;
    }
    .sign-btn__wrapper {
        margin-top: 30px;
        margin-right: 24px;
        padding-bottom: 25px;
    }

    .sign-up__button {
        text-decoration: none;
        outline: none;
        text-align: center;
        color: #2F2F2F;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        border-radius: 6px;
        background-color: #FFBF00;
        box-shadow: 0 2px 8px 0 #FFBF00;
        padding-bottom: 12px;
        padding-top: 12px;
        width: 100%;
        cursor: pointer;
        border: none;
        display: block;
    }

    .sign-up__button:disabled {
        color: white;
        background-color: #2f2f2f;
        box-shadow: 0 2px 8px 0 #2f2f2f;
    }

    .sign-up__button:hover {
        text-decoration: none;
        outline: none;
        cursor: pointer;
    }
    .privecy {
        text-decoration: none;
        outline: none;
        color: #FFBF00;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 24px;
    }

    .privecy:hover {
        text-decoration: none;
        outline: none;
        color: #FFBF00;
        cursor: pointer;
    }

</style>
